module.exports = __webpack_public_path__ + "static/mstile-144x144-959efce1e07000003d8542bfe5d03ea4.png";